import { extendTheme } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';
import { colors } from './Stitches';

const config = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
  fonts: {
    heading: 'EB Garamond',
  },
  styles: {
    global: (props: any) => ({
      body: {
        bg: mode('white', colors.dark.dark)(props),
      },
    }),
  },
};

export const theme = extendTheme(config);
